"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = function _default(_ref) {
  var shouldSpeakIncomingActivity = _ref.shouldSpeakIncomingActivity;
  return shouldSpeakIncomingActivity;
};
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJfZGVmYXVsdCIsIl9yZWYiLCJzaG91bGRTcGVha0luY29taW5nQWN0aXZpdHkiLCJleHBvcnRzIl0sInNvdXJjZVJvb3QiOiJjb3JlOi8vLyIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3NlbGVjdG9ycy9zaG91bGRTcGVha0luY29taW5nQWN0aXZpdHkudHMiXSwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHR5cGUgeyBSZWR1eFN0YXRlIH0gZnJvbSAnLi4vdHlwZXMvaW50ZXJuYWwvUmVkdXhTdGF0ZSc7XG5cbmV4cG9ydCBkZWZhdWx0ICh7IHNob3VsZFNwZWFrSW5jb21pbmdBY3Rpdml0eSB9OiBSZWR1eFN0YXRlKTogYm9vbGVhbiA9PiBzaG91bGRTcGVha0luY29taW5nQWN0aXZpdHk7XG4iXSwibWFwcGluZ3MiOiI7Ozs7OztlQUVlLFNBQUFBLFNBQUFDLElBQUE7RUFBQSxJQUFHQywyQkFBMkIsR0FBQUQsSUFBQSxDQUEzQkMsMkJBQTJCO0VBQUEsT0FBNEJBLDJCQUEyQjtBQUFBO0FBQUFDLE9BQUEsY0FBQUgsUUFBQSJ9